import pushDataLayer from './push_data_layer';
import getFieldValue from '../form_wizard/elements/getFieldValue';
import getCookieOrMeta from '../storage/getCookieOrMeta';
import { getLeadFormId } from '../elements/leadForm';

/**
 * Sends the account_created event to Google Tag Manager
 * @param {Element} form - The form object on the page
 * @param {*} data - The JSON data received from the createUserAsync call
 */
export function pushAccountCreated(form, obj = {}) {
  pushDataLayer(Object.assign({
    'event': 'account_created',
    'landing_page': getCookieOrMeta('landing_page'),
    'page': location.href.split('#')[0],
    'visitor_id': getCookieOrMeta('visitor-id'),
    'email': getFieldValue(form, 'email'),
  }, obj));
}

/**
 * Sends the lead_created event to Google Tag Manager
 * @param {Element} form - The form object on the page
 * @param {*} data - The JSON data received from the createUserAsync call
 */
export function pushLeadCreated(form, obj = {}) {
  pushDataLayer(Object.assign({
    'event': 'lead_created',
    'landing_page': getCookieOrMeta('landing_page'),
    'page': location.href.split('#')[0],
    'locale': getCookieOrMeta('locale'),
    'referer': getCookieOrMeta('referer'),
    'subject': getFieldValue(form, 'subjects'),
    'lead_type': 'learning_tools_lead',
    'leadform': getLeadFormId(form),
    'email': getFieldValue(form, 'email'),
    'visitor_id': getCookieOrMeta('visitor-id'),
  }, obj));
}

/**
 * Sends the lead_created event to Google Tag Manager
 * @param {Element} form - The form object on the page
 * @param {*} data - The JSON data received from the createUserAsync call
 */
 export function pushLeadUpdated(form, obj = {}) {
  pushDataLayer(Object.assign({
    'event': 'lead_updated',
    'landing_page': getCookieOrMeta('landing_page'),
    'page': location.href.split('#')[0],
    'locale': getCookieOrMeta('locale'),
    'referer': getCookieOrMeta('referer'),
    'subject': getFieldValue(form, 'subjects'),
    'lead_type': 'learning_tools_lead',
    'leadform': getLeadFormId(form),
    'email': getFieldValue(form, 'email'),
    'visitor_id': getCookieOrMeta('visitor-id'),
  }, obj));
}
